(function ($) {
  const behavior = 'polyu_theme.views-unformatted';
  Drupal.behaviors[behavior] = {
    attach: (context, settings) => {
    },
  };

  $(function () {
    init_checkboxes();
    init_reset_btn();
  });

  $(document).ajaxComplete(function () {
    init_checkboxes();
  });

  function init_checkboxes() {
    $('.views-exposed-form  .form-checkboxes').each(function () {
      const select_all_checkbox = $(this).find('.bef-toggle');
      if (select_all_checkbox.length == 0) {
        return;
      }

      const checkboxes = $(this).find('.bef-checkboxes');
      if (checkboxes.length == 0) {
        return;
      }

      if (checkboxes.find('input[type=checkbox]').length == checkboxes.find('input[type=checkbox][checked]').length) {
        select_all_checkbox.addClass("active");
      }
    });
  }

  function init_reset_btn() {
    $('.reset-btn').on('click', function(e) {
      if(e.target != $(this).find('input')[0]) {
        $(this).find('input').trigger('click');
      }
    });
  }
})(jQuery);
